import Stats from './component';

export default Stats;
